import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxDropdownButton, VtxMenu, VtxMenuItem } from '@vertexinc/vtx-ui-react-component-library';
import BulkActionsProps, { BulkAction } from './BulkActionsProps.interface';
import './bulk-actions.scss';

const BulkActions = ({
  title,
  selectedRowKeys,
  selectedRows,
  actions,
  clearSelection,
  type = 'primary',
}: BulkActionsProps): JSX.Element => {
  Logging.Debug('Bulk Actions');

  const renderActions = (): JSX.Element[] => {
    Logging.Debug('Bulk Actions', actions);

    // eslint-disable-next-line arrow-body-style
    return actions.map((action: BulkAction) => {
      return (
        <VtxMenuItem
          key={action.id}
          disabled={action.disabled}
          onClick={(event) => action?.onClick(selectedRowKeys, selectedRows, clearSelection)}
        >
          {action.name}
        </VtxMenuItem>
      );
    });
  };

  const renderMenu = (): JSX.Element => {
    Logging.Debug('Render Menu');

    return (
      <VtxMenu>
        {renderActions()}
      </VtxMenu>
    );
  };

  // Append the Number of Selected Rows
  const buttonTitle = selectedRowKeys && selectedRowKeys.length > 0 ? `${title} (${selectedRowKeys.length})` : title;

  return (
    <>
      <div className="bulkActions">
        <VtxDropdownButton
          overlay={renderMenu()}
          disabled={!selectedRowKeys || (selectedRowKeys?.length === 0)}
          btnProps={{ title: buttonTitle, type }}
        />
      </div>
    </>
  );
};

export default BulkActions;
